/* eslint-disable unicorn/no-nested-ternary */

// ========= IMPORTS =========
import React, { useState, useEffect } from "react";

import { Link, useParams } from "@reach/router";

import { Card, HeaderCard } from "./Play/Cards";
import Modal from "./Play/Modal";

/** @jsx jsx */
import { jsx, css } from "@emotion/core";

// ========= IMAGES =========
import textureBG from "../assets/img/jep-bg.png";
import brainScore from "../assets/img/brain-score.png";

// ========= FONT AWESOME =========
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

// ========= ASSETS =========
import copy from "../assets/copy/play";
import COLORS from "../assets/libs/colors";

// ========= MAIN =========
const Play = () => {
	const [score, setScore] = useState(0);
	const [isOpen, setIsOpen] = useState(false);
	const [isCorrect, setIsCorrect] = useState();
	const [currentInfo, setCurrentInfo] = useState({});
	const [currentSelection, setCurrentSelection] = useState({});
	const [cardStatus, setCardStatus] = useState([
		[true, true, true, true, true, true],
		[true, true, true, true, true, true],
		[true, true, true, true, true, true],
		[true, true, true, true, true, true],
	]);
	const [isFinished, setIsFinished] = useState(false);
	const [modalIsActive, setModalIsActive] = useState(false);

	// // ========= TEST =========
	// const [score, setScore] = useState(1000);
	// const [isOpen, setIsOpen] = useState(true);
	// const [isCorrect, setIsCorrect] = useState(true);
	// const [currentInfo, setCurrentInfo] = useState({
	// 	prompt: `This brain part is responsible for storing and sorting memories.`,
	// 	options: [
	// 		`What is the brainstem?`,
	// 		`What is the cerebellum?`,
	// 		`What is the hippocampus?`,
	// 		`What is the hypothalamus?`,
	// 	],
	// 	correctAnswer: `What is the hippocampus?`,
	// 	cashPrize: 200,
	// 	bold: `The hippocampus `,
	// 	response: `is the part of the brain responsible for storing and sorting memories.`,
	// 	color: `teal`,
	// 	type: `hippocampus`,
	// });
	// const [currentSelection, setCurrentSelection] = useState({});
	// const [cardStatus, setCardStatus] = useState([
	// 	// [true, true, true, true, true, true],
	// 	[true, false, false, false, false, false],
	// 	// [false, false, false, false, false, false],
	// 	[false, false, false, false, false, false],
	// 	[false, false, false, false, false, false],
	// 	[false, false, false, false, false, false],
	// ]);
	// const [isFinished, setIsFinished] = useState(true);
	// const [modalIsActive, setModalIsActive] = useState(false);
	// // ========= END TEST =========

	useEffect(() => {
		// setIsFinished(cardStatus.flat().every((value) => value === false));
		if (cardStatus.flat().every((value) => value === false) && !modalIsActive) {
			setIsOpen(true);
			setIsFinished(true);
		}
	}, [modalIsActive]);

	const triggerModal = (info) => {
		setCurrentInfo(info);
		setIsOpen(true);
	};

	const handleFormSubmit = (event) => {
		event.preventDefault();

		// do nothing if a radio button has not been selected
		if (currentSelection.value === undefined) return;

		// set according to (in)correct
		if (currentSelection.value === currentInfo.correctAnswer) {
			setScore(score + currentInfo.cashPrize);
			setIsCorrect(true);
		} else {
			setScore(score - currentInfo.cashPrize);
			setIsCorrect(false);
		}
	};

	const generateCards = () => {
		const cards = [];
		const types = [`cns`, `medulla`, `cerebellum`, `hippocampus`, `cortex`, `hypothalamus`];

		for (let y = 0; y < 4; y++) {
			for (let x = 0; x < 6; x++) {
				cards.push(
					<Card
						key={`card-${y}-${x}`}
						position={[y, x]}
						info={copy[types[x]][y]}
						color={COLORS[copy[types[x]][y].color]}
						{...{ cardStatus, setCardStatus, triggerModal }}
					/>
				);
			}
		}
		return cards;
	};

	return (
		<div
			css={css`
				display: flex;
				height: 100%;
			`}
		>
			{/* MODAL */}
			{isOpen && (
				<Modal
					{...{
						isCorrect,
						setIsCorrect,
						currentInfo,
						setCurrentInfo,
						setIsOpen,
						currentSelection,
						setCurrentSelection,
						handleFormSubmit,
						isFinished,
						setModalIsActive,
						score,
					}}
				/>
			)}

			{/* JEOPARDY GRID */}
			<div
				css={css`
					display: grid;
					grid-template-columns: repeat(6, minmax(0, 1fr));
					grid-template-rows: 1.5fr repeat(4, 1fr);
					gap: 1rem;

					height: 100%;
					width: 100%;

					padding: 1rem;
					box-sizing: border-box;
				`}
			>
				<HeaderCard header="Brain & Cental Nervous System" color={COLORS.green} />
				<HeaderCard header="Medulla" color={COLORS.blue} />
				<HeaderCard header="Cerebellum" color={COLORS.pink} />
				<HeaderCard header="Hippocampus" color={COLORS.teal} />
				<HeaderCard header="Cerebral Cortex" color={COLORS.blue} />
				<HeaderCard header="Hypothalamus" color={COLORS.gray} />

				{generateCards()}
			</div>

			{/* SIDEBAR */}
			<div
				css={css`
					display: flex;
					flex-direction: column;

					width: 20%;
					box-sizing: border-box;

					background-image: url(${textureBG});
					background-size: cover;
					background-repeat: no-repeat;
					background-position: center;

					padding-left: 1rem;

					color: white;
				`}
			>
				<img
					css={css`
						width: 100%;
						height: inherit;
					`}
					alt="All about the BRAIN"
					src={brainScore}
				/>
				<div
					css={css`
						display: flex;
						justify-content: center;
						align-items: center;
						height: 100%;

						font-size: 2em;
					`}
				>
					${score}
				</div>
				<Link to="/play/Brain_Trivia/how-to-play">
					<button
						type="button"
						css={css`
							color: white;

							background-color: transparent;
							border: none;

							margin-bottom: 30px;

							font-size: 0.8em;
							text-align: center;
						`}
					>
						HOW TO PLAY <FontAwesomeIcon icon={faQuestionCircle} />
					</button>
				</Link>
				{/* <div
					onClick={() => {
						setCardStatus([
							[true, false, false, false, false, false],
							[false, false, false, false, false, false],
							[false, false, false, false, false, false],
							[false, false, false, false, false, false],
						]);
					}}
				>
					CLICK TO TEST
				</div> */}
			</div>
		</div>
	);
};

export default Play;
